module.exports = __webpack_public_path__ + "img/banner-image.d8209826.png";